import Request from './Request';

class StorageService extends Request {

  constructor() {
    super('storage');
  }

  getReceipt(uuId) {
    const options = {
      method: 'GET'
    };
    return this.sendPdf({ path: `/storage/receipt/${uuId}`, options }).then((res) => res);
  }

  getAttachment(attachment) {
    const options = {
      method: 'GET'
    };
    return this.sendPdf({ path: `/storage/${attachment}`, options }).then((res) => res);
  }

  deleteAttachment(applicationUuId, attachment) {
    const options = { 
      method: 'DELETE'
    }
    return this.send({ path: `/attachment?name=${attachment}&applicationUuid=${applicationUuId}`, options })
  }

}

export default new StorageService();